<app-svg src="/assets/icons/64/{{icon}}.svg"></app-svg>
